import React from 'react'
import styles from "./style.module.css";
import { useState } from 'react';
import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';

const RootLayout = ({ children }) => {
    const [isActive, setIsActive] = useState(false);
    const divClassName = isActive ? 'sidebar active' : 'sidebar';
    const toggleActive = () => {
        setIsActive(!isActive);
    };
    return (
        <div className={styles.heading}>
            <section className={styles.sidebar_wrap}>
                <div className="body-wrap">
                    <div className="container-fluid px-0">
                        <div className="row">
                            <div className={`col col-sidebar  ${divClassName} `}>
                                <Sidebar />
                            </div>
                            <div className="col col-dashboard">
                                <Header isActive={isActive} toggleActive={toggleActive} />
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )}

export default RootLayout